// extracted by mini-css-extract-plugin
export default {"cardList":"ca","cardListItem":"da","blinking":"ea"};